import Link from "./LinkComponent";

export type { LinkProps } from "./LinkComponent";

export default Link;
